<div class="app-container">
    <div class="frame-container">
        <div class="header">
            <div class="window-title">
                <img src="assets\icons\terminal.jpg">
                <span>{{application.name}}</span>
            </div>
            <div class="window-icons">
                <!-- <div class="button-minimize"><img src="assets\icons\windows_minimize.png"></div> -->
                <div class="button-maximize" (click)="maximize()"><img src="assets/icons/windows_maximize.png"></div>
                <div class="button-close" (click)="close()"><img src="assets\icons\windows_close.png"></div>
            </div>
        </div>
        <iframe #applicationFrame [src]="this.sanitizerService.bypassSecurityTrustResourceUrl(link)"></iframe>
    </div>
    <div class="button close-button"></div>
    <div class="button new-tab-button"></div>
</div>